import React, { useState, useEffect } from 'react';
import { propertyService } from '../services/propertyService';
import './AreaSelectionModal.css';

const AreaSelectionModal = ({ isOpen, onClose, onNext, initialSelectedAreas = [] }) => {
    const [selectedAreas, setSelectedAreas] = useState(initialSelectedAreas);
    const [searchTerm, setSearchTerm] = useState('');
    const [propertyCount, setPropertyCount] = useState(0);
    const [availableAreas, setAvailableAreas] = useState([]);
    const [isLoadingAreas, setIsLoadingAreas] = useState(true);

    useEffect(() => {
        if (!isOpen) return;

        const loadAreas = async () => {
            setIsLoadingAreas(true);
            const areas = await propertyService.getUniqueLocalities();
            setAvailableAreas(areas);
            setIsLoadingAreas(false);
        };

        loadAreas();
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) return;

        const fetchCount = async () => {
            if (selectedAreas.length === 0) {
                setPropertyCount(0);
                return;
            }
            const count = await propertyService.getPropertyCountForLocalities(selectedAreas);
            setPropertyCount(count);
        };

        fetchCount();
    }, [selectedAreas, isOpen]);

    if (!isOpen) return null;

    const filteredAreas = availableAreas.filter(area =>
        area.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const toggleArea = (area) => {
        if (selectedAreas.includes(area)) {
            setSelectedAreas(selectedAreas.filter(a => a !== area));
        } else {
            setSelectedAreas([...selectedAreas, area]);
        }
    };



    return (
        <div className="modal-overlay">
            <div className="modal-content area-modal">
                <div className="modal-header">
                    <h2>Select Areas</h2>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>

                <div className="modal-body">
                    {/* Search Bar */}
                    <div className="area-search-container">
                        <input
                            type="text"
                            placeholder="Search areas..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="area-search-input"
                            autoFocus
                        />
                        {searchTerm && (
                            <button className="clear-search" onClick={() => setSearchTerm('')}>
                                &times;
                            </button>
                        )}
                    </div>

                    {/* Selected Chips */}
                    {selectedAreas.length > 0 && (
                        <div className="selected-chips-container">
                            {selectedAreas.map(area => (
                                <div key={area} className="area-chip">
                                    <span>{area}</span>
                                    <button onClick={() => toggleArea(area)}>&times;</button>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Area List */}
                    <div className="area-list">
                        {isLoadingAreas ? (
                            <div className="area-loading">Loading available areas...</div>
                        ) : filteredAreas.length === 0 ? (
                            <div className="area-empty">No areas found.</div>
                        ) : (
                            filteredAreas.map(area => (
                                <div
                                    key={area}
                                    className={`area-item ${selectedAreas.includes(area) ? 'selected' : ''}`}
                                    onClick={() => toggleArea(area)}
                                >
                                    <div className="checkbox-custom">
                                        {selectedAreas.includes(area) && <span>&#10003;</span>}
                                    </div>
                                    <span className="area-name">{area}</span>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        className="next-btn"
                        disabled={selectedAreas.length === 0}
                        onClick={() => onNext(selectedAreas)}
                    >
                        Next ({propertyCount} {propertyCount === 1 ? 'property' : 'properties'}) &rarr;
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AreaSelectionModal;
